import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const headerDefaultVariants = {
  "size": "md"
}
const headerCompoundVariants = []

const headerSlotNames = [
  [
    "root",
    "header__root"
  ],
  [
    "left",
    "header__left"
  ],
  [
    "right",
    "header__right"
  ],
  [
    "center",
    "header__center"
  ],
  [
    "title",
    "header__title"
  ]
]
const headerSlotFns = /* @__PURE__ */ headerSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, headerDefaultVariants, getSlotCompoundVariant(headerCompoundVariants, slotName))])

const headerFn = memo((props = {}) => {
  return Object.fromEntries(headerSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const headerVariantKeys = [
  "size",
  "hideBorder"
]
const getVariantProps = (variants) => ({ ...headerDefaultVariants, ...compact(variants) })

export const header = /* @__PURE__ */ Object.assign(headerFn, {
  __recipe__: false,
  __name__: 'header',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: headerVariantKeys,
  variantMap: {
  "size": [
    "xs",
    "sm",
    "md"
  ],
  "hideBorder": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, headerVariantKeys)
  },
  getVariantProps
})